import { GenericConfirmComboButton, UncontrolledModal } from "@cadmakers-ui/core";
import React, { useEffect, useState } from "react";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import { MultiUserSelector, User } from "../../../../User";
import { setFeedbackAssignedUsers } from "../../../Api";
import styles from "../../../Styles/FeedbackAssignmentModal.module.scss";

type Props = {
  feedbackName: string;
  feedbackCode: string;
  defaultSelectedUsers: User[];
  isOpen: boolean;
  toggle: () => void;
  onSaveChanges: (users: User[]) => void;
};

const FeedbackAssignmentModal: React.FC<Props> = props => {
  const [selectedUsers, setSelectedUsers] = useState<User[]>([]);
  const [didSetDefualtUsers, setDidSetDefaultUsers] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  // set the selected Ids on initial load, and whenever the defaults change
  useEffect(() => {
    if (!didSetDefualtUsers) {
      setSelectedUsers(props.defaultSelectedUsers);
      setDidSetDefaultUsers(true);
    }
  }, [props.defaultSelectedUsers, didSetDefualtUsers]);

  const onSelectedUsersChange = (users: User[]) => {
    setSelectedUsers(users);
  };

  const onClickSaveChanges = async () => {
    if (isSaving) return;

    setIsSaving(true);

    try {
      await setFeedbackAssignedUsers(
        props.feedbackCode,
        selectedUsers.map(u => u.id)
      );
      props.onSaveChanges(selectedUsers);
    } catch (e) {
      // TODO add good error handler
      console.error(e);
    }

    setIsSaving(false);
  };

  return (
    <Modal isOpen={props.isOpen} toggle={props.toggle}>
      <ModalBody>
        <p>
          Assign users to <b>{props.feedbackName}</b> below, and click &quot;Save Changes&quot; when
          you are done
        </p>
        <MultiUserSelector
          selectedIds={selectedUsers.map(u => u.id)}
          onSelectedUsersChange={onSelectedUsersChange}
        />
      </ModalBody>
      <ModalFooter>
        <div className={styles.confirmButtons}>
          <Button color="primary" style={{ marginRight: "10px" }} onClick={onClickSaveChanges}>
            Save Changes
          </Button>
          <Button color="secondary" onClick={props.toggle}>
            Cancel
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default FeedbackAssignmentModal;
